import axiosInstance from '../main/axios';

export function getLeituraAtual(controladorId) {
  const request = axiosInstance.get(`/pluviometro/dados/${controladorId}`);
  return {
    type: 'PLUVIOMETRO_LEITURA_ATUAL_FETCHED',
    payload: request,
  };
}

export function salvarLeitura(dados) {
  const request = axiosInstance.post('/pluviometro/salvar', dados);
  return {
    type: 'PLUVIOMETRO_LEITURA_SAVED',
    payload: request,
  };
}

export function getHistorico(controladorId, filtros = {}) {
  const params = new URLSearchParams();

  if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
  if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
  if (filtros.agrupamento) params.append('agrupamento', filtros.agrupamento);

  const url = `/pluviometro/historico/${controladorId}${params.toString() ? '?' + params.toString() : ''}`;
  const request = axiosInstance.get(url);

  return {
    type: 'PLUVIOMETRO_HISTORICO_FETCHED',
    payload: request,
  };
}

export function getConfig(controladorId) {
  const request = axiosInstance.get(`/pluviometro/config/${controladorId}`);
  return {
    type: 'PLUVIOMETRO_CONFIG_FETCHED',
    payload: request,
  };
}

export function updateConfig(controladorId, config) {
  const request = axiosInstance.put(`/pluviometro/config/${controladorId}`, config);
  return {
    type: 'PLUVIOMETRO_CONFIG_UPDATED',
    payload: request,
  };
}

export function getEstatisticas(controladorId) {
  const request = axiosInstance.get(`/pluviometro/estatisticas/${controladorId}`);
  return {
    type: 'PLUVIOMETRO_ESTATISTICAS_FETCHED',
    payload: request,
  };
}

export function clearData() {
  return {
    type: 'PLUVIOMETRO_CLEAR_DATA',
  };
}
